import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FakturaView, InvoiceFilterOptions, InvoiceListPeriod } from '@store/models';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FakturaService } from './services/faktura.service';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InvoicesComponent {
    @Input() searchFor: string;
    filterOptions: InvoiceFilterOptions;
    invoices$: Observable<FakturaView[]>;
    markedInvoices = [];
    dateOptions: InvoiceListPeriod;

    constructor(
        private fakturaService: FakturaService,
        private activeModal: NgbActiveModal,
        private cdRef: ChangeDetectorRef
    ) { }

    onFilterOptions(filterOptions: InvoiceFilterOptions) {
        this.filterOptions = filterOptions;
    }

    onDateOptions(dateOptions: InvoiceListPeriod) {
        this.dateOptions = dateOptions;
        this.loadInvoices();
        this.cdRef.detectChanges();
    }

    loadInvoices() {
        this.invoices$ = this.fakturaService.fakturaViewByOffice(this.dateOptions);
    }

    onMarkedInvoices(markedInvoices: number[]) {
        this.markedInvoices = markedInvoices;
    }

    godkendMarked() {
        this.fakturaService.godkendFakturaBulk(this.markedInvoices).pipe(
            tap(() => this.onDateOptions(this.dateOptions))
        ).subscribe();
    }

    onDismiss() {
        this.activeModal.dismiss();
    }
}
